var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowSimpleLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 33 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32.395 66.242 10.7 44.547c-4.937-4.938-4.937-12.973 0-17.91L32.388 4.95 27.437 0 5.751 21.687c-7.668 7.667-7.668 20.143 0 27.81l21.694 21.695 4.95-4.95Z",
  fill: "currentColor"
})));
export default SvgArrowSimpleLeft;